import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  glow?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  glow = false,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'relative inline-flex items-center justify-center font-bold tracking-wide transition-all duration-300 rounded-sm overflow-hidden group';
  const variants = {
    primary: 'bg-neon-cyan text-black hover:bg-white border-2 border-neon-cyan hover:border-white',
    secondary: 'bg-neon-magenta text-white hover:bg-white hover:text-neon-magenta border-2 border-neon-magenta',
    outline: 'bg-transparent text-white border-2 border-white/20 hover:border-neon-amber hover:text-neon-amber'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg'
  };
  const glowClass = glow ? variant === 'primary' ? 'shadow-[0_0_20px_rgba(0,240,255,0.5)]' : variant === 'secondary' ? 'shadow-[0_0_20px_rgba(255,45,123,0.5)]' : '' : '';
  return <motion.button whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${glowClass} ${className}`} {...props} data-id="element-211">
      <span className="relative z-10 flex items-center gap-2" data-id="element-212">{children}</span>

      {/* Glitch effect overlay on hover could go here */}
      <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-out" data-id="element-213" />
    </motion.button>;
}